import { preLoginLogo } from "../../styles/preLoginBranding";
import {
  PreLoginContainer,
  PreLoginHeader,
  PreLoginLogo,
} from "./NotFound.styles";
import { NotFoundContent, NotFoundReason } from "./NotFoundContent";

interface INotFoundProps {
  reason?: NotFoundReason;
}

/**
 * EN-2750. The standalone 404 page — the `*-login-404-error` design variant:
 * the brand bar over the error block, and nothing else.
 *
 * Used for an unknown URL with no portal session, and as the fallback for the
 * app-level ErrorBoundary in App.tsx, where "nothing else" is the point: it
 * renders none of the chrome that might itself be what crashed.
 *
 * A signed-in user gets the same block inside the real top panel instead —
 * see the catch-all route in routes/routes.tsx and the boundary inside
 * DashboardLayout. Deliberately no import of DashboardLayout here: routes.tsx
 * builds its elements at module scope, and this module sits in that cycle.
 */
export function NotFound({ reason }: INotFoundProps) {
  return (
    <PreLoginContainer>
      <PreLoginHeader>
        <PreLoginLogo src={preLoginLogo.src} alt={preLoginLogo.alt} />
      </PreLoginHeader>

      <NotFoundContent reason={reason} />
    </PreLoginContainer>
  );
}
